import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProcessViewer from './components/ProcessViewer';
import ProcessService from './services/ProcessService';
import { 
  ArrowLeft,
  GitBranch,
  FileText,
  Code,
  Activity,
  CheckCircle,
  AlertTriangle,
  Clock,
  ChevronRight,
  ChevronDown,
  MessageSquare
} from 'lucide-react';

// Composants UI base adaptés à la charte
const Card = ({ children, className = '' }) => (
  <div className={`bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 ${className}`}>
    {children}
  </div>
);

const ProcessDetailPage = () => {
  const { processId } = useParams();
  const navigate = useNavigate();
  const [process, setProcess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProcess = async () => {
      try {
        setLoading(true);
        const foundProcess = await ProcessService.loadProcessById(processId);
        setProcess(foundProcess);
      } catch (error) {
        console.error('Error loading process:', error);
      } finally {
        setLoading(false);
      }
    };

    loadProcess();
  }, [processId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050A1C] p-8 flex items-center justify-center">
        <div className="text-white/70">Chargement...</div>
      </div>
    );
  }

  if (!process) {
    return (
      <div className="min-h-screen bg-[#050A1C] p-8 flex items-center justify-center">
        <div className="text-white/70">Processus non trouvé</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050A1C]">
      <button
        onClick={() => navigate(-1)}
        className="mb-8 flex items-center gap-2 text-white/70 hover:text-white group p-8"
      >
        <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
        Retour
      </button>
      
      {process && <ProcessViewer processData={process} />}
      {!process && <div className="text-white/70 p-8">Aucun processus trouvé</div>}
    </div>
  );
};

export default ProcessDetailPage;